import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function RobotIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <g opacity=".7" fillRule="evenodd" clipRule="evenodd" fill="currentColor">
        <path d="M7.5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m11-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0M10 15.5a.5.5 0 0 1 .5.5v.003l.003.01q.005.015.036.054a.9.9 0 0 0 .271.194c.278.139.699.24 1.19.24s.912-.101 1.19-.24a.9.9 0 0 0 .271-.194.2.2 0 0 0 .036-.054l.003-.01V16a.5.5 0 0 1 1 0c0 .568-.447.947-.862 1.154-.445.223-1.025.346-1.638.346s-1.193-.123-1.638-.346C9.947 16.947 9.5 16.567 9.5 16a.5.5 0 0 1 .5-.5" />
        <path d="M16 5.5v2H8v-2a.5.5 0 0 0-1 0v2H6A2.5 2.5 0 0 0 3.5 10v7A2.5 2.5 0 0 0 6 19.5h12a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 18 7.5h-1v-2a.5.5 0 0 0-1 0m-10 3A1.5 1.5 0 0 0 4.5 10v7A1.5 1.5 0 0 0 6 18.5h12a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 18 8.5z" />
      </g>
    </BaseIcon>
  );
}
